export { default as couponsService } from './coupons-service'
